import { Handle } from "react-flow-renderer";
import styled, { css } from "styled-components";

export const ConditionalStyle = styled.div`
  width: 43px;
  height: 43px;
  box-sizing: border-box;
  border-radius: 2px;

  transform: rotate(-45deg);
  font-size: 17px;
  background-color: #fff;

  box-shadow: 0 0 0 1.2px #42464c;
  &.critical {
    border: 4px solid #d93333 !important;
  }

  ${({ status }) =>
    status === "doing"
      ? css`
          background-color: #f9e169;
        `
      : status === "pending"
      ? css`
          background-color: #fff;
        `
      : status === "done"
      ? css`
          background-color: #a0f69e;
        `
      : null}
`;

export const HandleStyle = styled(Handle)`
  width: 8px;
  height: 8px;
`;
export const Condi = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 17px;
`;
